;(function($){

	$.fn.shopgateTermsModal = function(options) {

		var defaults = {
			offsetTop: 10,
			offsetBottom: 10
		};

		options = options || {};
		options = $.extend(true,{}, defaults, options);

		return this.each(function(){
			var that = $(this),
				modal = null,
				menuBarVisible = false;

			that.click(function(e){
				e.preventDefault();
				e.stopPropagation();

				var url = this.href;

				// save the current state of the menuBar (visible or not) so that we can display the menuBar again if it was visible before
				if (typeof pageInformation != 'undefined' && typeof pageInformation.menuBarVisible != 'undefined') {
					menuBarVisible = pageInformation.menuBarVisible;
				}

				$.shopgate.ajax({
					type: "POST",
					url: url,
					beforeSend: function(jqXHR, settings){
						$(document).trigger('shopgateFramework.waitingIndicator.show');
						if (menuBarVisible) {
							SGAction.hideMenuBar();
						}
					},
					success: function(data, textStatus, jqXHR){

						if(data.html){
							var content = $(data.html).find('.terms-wrapper').html();
							modal = '<div class="modal terms-modal" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">'
								+ '	<div class="modal-dialog">'
								+ '		<div class="modal-content">'
								+ '			<div class="modal-header">'
								+ '				<button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>'
								+ '				<h4 class="modal-title">&nbsp;</h4>'
								+ '			</div>'
								+ '			<div class="modal-body">'
								+ '				<div class="terms-content">' +  content + '</div>'
								+ '			</div>'
								+ '		</div>'
								+ '	</div>'
								+ '</div>';

							var browserHeight = window.innerHeight,
								$termsModal = $(modal),
								$termsModalHeader = $termsModal.find('.modal-header'),
								$termsModalContent = $termsModal.find('.modal-content'),
								$termsModalBody = $termsModal.find('.modal-body'),
								$categoryHeadline = $termsModal.find('.category-headline');

							// append the new one
							$('body').append($termsModal);

							// add headline
							$termsModal.find('.modal-title').text($categoryHeadline.find('h1').text());
							$categoryHeadline.find('h1').remove();

							// show the current modal
							$termsModal.modal(
								{backtrop: true},
								'show'
							).on('hide.bs.modal', function() {
								if (menuBarVisible) {
									SGAction.showMenuBar();
								}
							}).on('hidden.bs.modal', function() {
								$termsModal.remove();
							});

							var modalHeaderHeight = $termsModalHeader.outerHeight(),
								offsetTop = options.offsetTop + SGViewState.getInset('top'),
								offsetBottom = options.offsetBottom; // + SGViewState.getInset('bottom');

							// calculate the height of the modal body
							$termsModalContent.css({'height':browserHeight-offsetTop-offsetBottom, 'overflow':'hidden'});
							$termsModalBody.css({'height':browserHeight-modalHeaderHeight-offsetTop-offsetBottom});
							$termsModal.find('.terms-content').css({'height':browserHeight-modalHeaderHeight-offsetTop-offsetBottom});

							$termsModal.css({'visibility':'visible'});
						}
					},
					complete: function(jqXHR, textStatus){
						$(document).trigger('shopgateFramework.waitingIndicator.hide');
					}
				});
			});
		});
	}

})(jQuery);



// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-terms-modal.js